var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_2576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.16121 0 0.185181 7.97603 0.185181 17.8148C0.185181 27.6536 8.16121 35.6296 18 35.6296C27.8395 35.6296 35.8148 27.6536 35.8148 17.8148C35.8148 7.97603 27.8395 0 18 0ZM18 32.0667C10.1415 32.0667 3.74814 25.6733 3.74814 17.8148C3.74814 9.95632 10.1415 3.56296 18 3.56296C25.8585 3.56296 32.2518 9.95632 32.2518 17.8148C32.2518 25.6733 25.8585 32.0667 18 32.0667Z",
    fill: "#FFCB5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4796 16.5678L15.8401 11.5797C14.6523 10.8942 13.6803 11.455 13.6803 12.8267V22.803C13.6803 24.1748 14.6523 24.7363 15.8401 24.0501L24.4796 19.0619C25.6675 18.3764 25.6675 17.2534 24.4796 16.5678Z",
    fill: "#FFCB5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_2576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.6296,
    height: 35.6296,
    fill: "white",
    transform: "translate(0.185181)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon-play.29bfe7d6a1bade84f9b2e0a43789790c.svg";
export { ForwardRef as ReactComponent };